import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'

import LoginLayout from '../../layout/LoginLayout'
import LoaderComponent from '../../components/CommonComponents/LoaderComponent'

import { emailValidator } from '../../utils/validator'
import { doSignup } from '../../redux/actions/auth'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import LeftImageComponent from '../../components/CommonComponents/LeftImageComponent'
import Image from '../../assets/img/signup.png'
import {HiOutlineUser } from 'react-icons/hi'
import {AiOutlineMail } from 'react-icons/ai'
import {RiErrorWarningLine } from 'react-icons/ri'
import { BsEye, BsEyeSlash } from "react-icons/bs";

const SignupPage = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useStore().getState()

  const { auth } = store
  const { isLoggedIn, isLoading } = auth

  const [emailValues, setEmail] = useState({
    email : '',
    emailError : ''
  })
  const [passwordValues, setPassword] = useState({
    password: "",
    showPassword : false,
    pwdError : ''
  })
  const [firstNameValues, setFirstName] = useState({
    firstName : '',
    fNameError : ''
  })
  const [lastNameValues, setLastName] = useState({
    lastName : '',
    lNameError : ''
  })

  // const [userName, setUserName] = useState('')
  const [userName, setUserName] = useState('subdomain')

  useEffect(() => {
    if (isLoggedIn) {
      history.push('/dashboard')
    }
  }, [isLoggedIn, history])

  const onSignup = () => {
    if (!emailValues.email || emailValues.email === '') {
      emailValues.emailError = 'Email should not be empty!'
    } else {
      if (!emailValidator(emailValues.email)) {
        emailValues.emailError = 'This email is invalid'
      } else {
        emailValues.emailError = ''
      }
    }

    if (!userName || userName === '') {
      toast.show({
        title: 'Success',
        description: 'Please enter your username',
      })
      return
    }

    if (!passwordValues.password || passwordValues.password === '') {
      passwordValues.pwdError = 'Password should not be empty!';
    } else {
      passwordValues.pwdError = '';
    }
 
    if (!firstNameValues.firstName || firstNameValues.firstName === '') {
      firstNameValues.fNameError = 'First name should not be empty!';
    } else {
      firstNameValues.fNameError = '';
    }

    if (!lastNameValues.lastName || lastNameValues.lastName === '') {
      lastNameValues.lNameError = 'Last name should not be empty!';
    } else {
      lastNameValues.lNameError = '';
    }

    if(lastNameValues.lNameError === '' && firstNameValues.fNameError === '' && emailValues.emailError === '' && passwordValues.pwdError === '') {
      dispatch(doSignup({
        email: emailValues.email,
        password: passwordValues.password,
        firstName: firstNameValues.firstName,
        lastName: lastNameValues.lastName,
        userName
      })).then(() => {
        history.push('/login')
      })
    } else {
      setLastName({...lastNameValues})
      setFirstName({...firstNameValues})
      setEmail({...emailValues})
      setPassword({...passwordValues})
    }
  }

  const showPassword = () => {
    setPassword({...passwordValues, showPassword: !passwordValues.showPassword})
  }

  const handleInputChange = (prop) => (event) => {
    if (prop === 'password') {
      if (passwordValues.password) {
        passwordValues.pwdError = ''
      }
      setPassword({ ...passwordValues, [prop]: event.target.value });
    } else if (prop === 'email') {
      if (emailValues.email) {
        if (!emailValidator(emailValues.email)) {
          emailValues.emailError = 'This email is invalid'
        } else {
          emailValues.emailError = ''
        }
      }
      setEmail({ ...emailValues, [prop]: event.target.value });
    } else if (prop === 'firstName') {
      if (firstNameValues.firstName) {
        firstNameValues.fNameError = ''
      }
      setFirstName({ ...firstNameValues, [prop]: event.target.value })
    } else {
      if (lastNameValues.lastName) {
        lastNameValues.lNameError = ''
      }
      setLastName({ ...lastNameValues, [prop]: event.target.value })
    }
  };

  return (
    <LoginLayout>
      <div className="signup-page">
        <div className='signup-left'>
          <LeftImageComponent image={Image} quote="Great for supplier or consigner businesses" quoteby="-kim G, California, US"/>
        </div>
        {/* <LeftImageComponent/> */}
        <div className={`signup-right ${isLoading && 'loading'}`}>
          {isLoading && <LoaderComponent />}
          <div className="form-content">
            <div className="form-title">
              <h4>Sign Up</h4>
              <span>Already have an Account? <Link to="/login">Sign in</Link></span>
            </div>
            <div className="form-input-container">
              <div className={`form-input-inner ${firstNameValues.fNameError ? '' : 'has-bottom-margin'}`}>
                <div className="form-input">
                  <input className={`${firstNameValues.fNameError ? 'error-border' : ''}`} type="text" placeholder="First Name" value={firstNameValues.firstName} onChange={handleInputChange("firstName")} />
                  <HiOutlineUser color="#104569" size={24} />
                </div>
                {firstNameValues.fNameError && (
                  <div className='error-container flex align-center'>
                    <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                    <p className='error mb-2'>{firstNameValues.fNameError}</p>
                  </div>
                )}
              </div>
              <div className={`form-input-inner ${lastNameValues.lNameError ? '' : 'has-bottom-margin'}`}>
                <div className="form-input">
                  <input className={`${lastNameValues.lNameError ? 'error-border' : ''}`} type="text" placeholder="Last Name" value={lastNameValues.lastName} onChange={handleInputChange("lastName")} />
                  <HiOutlineUser color="#104569" size={24} />
                </div>
                {lastNameValues.lNameError && (
                  <div className='error-container flex align-center'>
                    <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                    <p className='error mb-2'>{lastNameValues.lNameError}</p>
                  </div>
                )}
              </div>
                {/* <input type="text" placeholder="User Name" value={userName} onChange={(e) => setUserName(e.target.value)} /> */}
              <div className="form-input disabled">
                <input type="text" placeholder="SubDomain Name" value={userName} hidden disabled onChange={(e) => setUserName(e.target.value)} />
              </div>
              <div className={`form-input-inner ${emailValues.emailError ? '' : 'has-bottom-margin'}`}>
                <div className="form-input">
                  <input className={`${emailValues.emailError ? 'error-border' : ''}`} type="text" placeholder="Email Address" value={emailValues.email} onChange={handleInputChange("email")} />
                  <AiOutlineMail color="#104569" size={24} />
                </div>
                {emailValues.emailError && (
                  <div className='error-container flex align-center'>
                    <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                    <p className='error mb-2'>{emailValues.emailError}</p>
                  </div>
                )}
              </div>
              <div className={`form-input-inner ${passwordValues.pwdError ? '' : 'has-bottom-margin'}`}>
                <div className="form-input">
                  <input className={`${passwordValues.pwdError ? 'error-border' : ''}`} type={passwordValues.showPassword ? "text" : "password"} placeholder="Type Password" value={passwordValues.password} onChange={handleInputChange("password")} />
                  {passwordValues.showPassword ? 
                    <BsEye color="#104569" size={24} onClick={showPassword}/> :
                    <BsEyeSlash color="#104569" size={24} onClick={showPassword}/>
                  }
                </div>
                {passwordValues.pwdError && (
                  <div className='error-container flex align-center'>
                    <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                    <p className='error mb-2'>{passwordValues.pwdError}</p>
                  </div>
                )}
              </div>
                <button type="button" className="btn-login" onClick={onSignup}>Sign Up</button>
            </div>
          </div>
          <div className='privacy-copyright-container'>
            <span> Privacy Policy </span>
            <span> Copyright 2022 </span>
          </div>
        </div>
      </div>
    </LoginLayout>
  )
}

export default SignupPage
